<template lang="pug">
  fieldset.product-ship-options.xs-f-small.lg-f-medium.max-at-tweak
    MrRadio(v-model="modelValue" :value="false" :name="'Order option' + _uid").row
      .inline-block
        span Ship with next order

      template(v-if="subPrice")
        span.float-right {{ oneTimePrice | currency }}

    MrRadio(v-model="modelValue" :value="true" :name="'Order option' + _uid").row
      .inline-block
        span Ship with every order
        .color-slate.xs-f-xsmall.lg-f-small.max-at-tweak Cancel online anytime

      template(v-if="subPrice")
        span.float-right {{ subPrice | currency }}


</template>

<script>

  import MrRadio from "../mrRadio";
  export default {
    name: "ProductShipOptions",
    components: {MrRadio},

    model: {
      prop: 'value',
      event: 'change'
    },

    props: {
      value: {
        type: Boolean
      },

      oneTimePrice: {
        require: false
      },

      subPrice: {
        required: false
      }
    },

    computed: {
      modelValue: {
        get() {
          return this.value;
        },

        set(val) {
          this.$emit('change', val);
        }
      }
    }
  }
</script>

<style scoped lang="stylus">
  .product-ship-options
    padding 1em 0
    width 100%

    .radio-label
      padding-bottom 1em

      .mr-radio
        margin-top 0.15em
</style>